import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";

const GET_DUPLICATES_KEY = "duplicates";
const GET_DUPLICATE_COUNT_KEY = "duplicateCount";

export const duplicateKeys = createKeys(
  featureKeys.DUPLICATES,
  {
    getDuplicates: () => [GET_DUPLICATES_KEY],
    getDuplicateCount: () => [GET_DUPLICATE_COUNT_KEY],
  }
);
